import { Component, input, signal, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PrimeNGModule } from '@/app/config/primeng';
import { OmniMqttService } from '@/app/core/mqtt/omni-mqtt.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-meeting-rooms',
    standalone: true,
    imports: [CommonModule, SelectButtonModule, FormsModule, PrimeNGModule],
    templateUrl: './meeting-rooms.component.html',
})
export class MeetingRoomsComponent {
    private mqtt = inject(OmniMqttService);
    deviceTable = toSignal(this.mqtt.deviceTable$, { initialValue: {} });

    rooms = input<any[]>([]);

    scopeOptions: any[] = [
        { label: '14F', value: '14F' },
        { label: '15F', value: '15F' }
    ];

    selectedScope = signal('14F');

    // Dynamically computed stats based on MQTT panel data
    stats = computed(() => {
        const table = this.deviceTable();
        const scope = this.selectedScope();
        
        let total = 0;
        let idle = 0;
        let reserved = 0;
        let inUse = 0;

        Object.values(table).forEach((device: any) => {
            if (device.type === 'PANEL' && device.name.includes(`_${scope}`)) {
                total++;
                const statusValue = device.data?.['01_1']?.value;
                if (statusValue === 0) idle++;
                else if (statusValue === 1) reserved++;
                else if (statusValue === 2) inUse++;
                else idle++; // 預設或不存在時算閒置
            }
        });

        return {
            reserved: { count: reserved, total: total },
            idle: { count: idle, total: total },
            inUse: { count: inUse, total: total }
        };
    });
}
